// components/FeatureSection.jsx
import React from "react";
import "./featuresection.css";

const AussieFeatureSection = () => {
  return (
    <section className="feature-wrapper">
      <div className="image-container">
        <img src="/Images/best coffee shop mandurah.webp" alt="Cafe" className="animated-image" loading="lazy"/>
        <div className="circle yellow"></div>
        <div className="circle white"></div>
        <div className="sb-experience">
          <div className="sb-exp-content">
            <p className="sb-h1 sb-mb-10">
              {" "}
              <span> 100</span>
            </p>
            <p class="sb-h3">
              {" "}
              <span> Happy Customer </span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-container">
        {/* <h2>We are doing more than you expect</h2> */}

        <div className="feature-block">
          {/* <span className="monoton">01</span> */}
          <div>
            <h3>Top Rated Aussie Breakfast Spot in Mandurah</h3>
            <p>
              Start your day with the most satisfying Aussie Breakfast in
              Mandurah at Mandurah Cafe. Whether you're craving eggs, toast,
              bacon, or a hearty veggie plate, we serve the best combinations to
              fuel your morning. Enjoy the warm ambiance of our cafe right in
              the heart of Mandurah city center.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">02</span> */}
          <div>
            {/* <h3>Fresh, organic ingredients</h3> */}
            <p>
              We’ve carefully crafted our Aussie Breakfast menu using fresh
              local ingredients and authentic flavors. From classic brekkie to
              modern twists, Mandurah locals love our cozy vibes and delicious
              offerings. If you’re searching for a cafe in Mandurah that truly
              captures the Aussie spirit, you’re in the right place.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">03</span> */}
          <div>
            {/* <h3>Own fast delivery</h3> */}
            <p>
              Looking for the best Aussie Breakfast near you in Mandurah?
              Whether you're on your way to work or enjoying a weekend brunch,
              Mandurah Cafe offers dine-in and takeaway options for everyone.
              Come in early and enjoy the taste of a true Mandurah morning.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AussieFeatureSection;
